import { CREATE_FAVORITE_BOARD } from "./actionTypes";

export default (boardName, objectType) => ({
  type: CREATE_FAVORITE_BOARD,
  payload: {
    boardName,
    objectType
  },
});